<template>
  <w-modal
    v-model="show"
    class="modal-static-footer"
    close-button="Anuluj"
    submit-button="Zapisz"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="$emit('close')"
  >
    <div class="mb-4">
      <w-button class="btn btn-light mr-3" text="Zaznacz wszystkie" @click="selectAll" />

      <w-button class="btn btn-light mr-3" text="Odznacz wszystkie" @click="unselectAll" />
    </div>

    <div class="row ml-0 mr-0">
      <w-checkbox
        v-for="(option, index) of options"
        :key="'checkbox_' + index"
        :class="checkboxClass"
        :model="$schema.list"
        :value="option.value"
        :title="option.text"
      />
    </div>
  </w-modal>
</template>

<script>
import { formMixin } from '@/mixins/form';
import { modalMixin } from '@/mixins/modal';
import schema from '@/schemas/checkboxList.schema';

// @vuese
// Modal służący do wyboru listy elementów za pomocą checkboxów
export default {
  mixins: [formMixin, modalMixin],
  schema,
  props: {
    // Tytuł modala
    title: { type: String, required: false },
    // Opcje do wyboru
    options: { type: Array, required: true },
    // Wybrane opcje
    selectedOptions: { type: Array, required: false },
    // Klasa dodawana do checkboxa
    checkboxClass: { type: String, required: false, default: 'col-12' }
  },
  data() {
    return { model: { list: [] } };
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.$schema.$setData({ list: this.selectedOptions || [] }, undefined, true);
      }
    }
  },
  methods: {
    // @vuese
    // Zapisuje wybrane kolumny
    save() {
      this.$emit('save', this.$schema.$getData().list);
    },

    // @vuese
    // Zaznacza wszystkie elementy
    selectAll() {
      this.$schema.list.$setData(
        this.options.map(option => option.value),
        undefined,
        true
      );
    },

    // @vuese
    // Odznacza wszystkie elementy
    unselectAll() {
      this.$schema.list.$setData([], undefined, true);
    }
  }
};
</script>
